import React from 'react'

import ProductsOverviewWrapper from '../../../react4xp/components/ProductsOverviewWrapper'


function ProductsOverviewPart({title, endpoint, categories, additionalPackaging, startValues, strings}) {
	return (
		<ProductsOverviewWrapper
			title={title}
			endpoint={endpoint}
			categories={categories}
			startValues={startValues}
			strings={strings}
		/>	
	)
}

export default (props) => <ProductsOverviewPart {...props} />
